

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/cart/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/3.x0eQPEXu.js","_app/immutable/chunks/Z8InAVTp.js","_app/immutable/chunks/BhyBrltq.js","_app/immutable/chunks/0gZYJLaf.js","_app/immutable/chunks/DYFTuOFP.js","_app/immutable/chunks/xihTtKlq.js","_app/immutable/chunks/BupqdC2b.js"];
export const stylesheets = [];
export const fonts = [];
